import { LatLng, latLng, LatLngTuple, MapOptions, tileLayer, TooltipOptions } from 'leaflet';

export const worldBounds: LatLngTuple[] = [
  [-90, -180],
  [90, 180]
];
export const centerBounds: LatLng = latLng(20.0, 0.0);
export const zoomOptions = {
  min: 2.5,
  max: 10,
  initial: 1.75,
  snap: 0.1,
  twoMarkersMax: 8
};

// Esri World Light Gray Canvas. Keyless, so no API key ends up in the committed bundle.
// Note the path order is {z}/{y}/{x} (not {z}/{x}/{y}), there is no {s} subdomain and no
// retina {r} variant — do not copy the tile-URL shape from other Leaflet providers.
export const copyrightLayer = tileLayer(
  'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
  {
    attribution:
      '&copy; <a href="https://www.esri.com">Esri</a>, HERE, Garmin, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    noWrap: false,
    bounds: worldBounds
  }
);

export const leafletOptions: MapOptions = {
  zoomControl: true,
  maxZoom: zoomOptions.max,
  minZoom: zoomOptions.min,
  center: centerBounds,
  zoom: zoomOptions.initial,
  zoomSnap: zoomOptions.snap,
  worldCopyJump: true,
  maxBounds: worldBounds,
  maxBoundsViscosity: 0.5,
  layers: [copyrightLayer]
};

export const tooltipOptions = {
  origin: {
    permanent: true,
    direction: 'top',
    offset: [-5, -10]
  } as TooltipOptions,
  destination: {
    permanent: true,
    direction: 'top',
    offset: [-5, -15]
  } as TooltipOptions
};
